import type { Mission } from '../missions.ts'

export const eoir: Mission = {
  id: "eoir",
  name: "Executive Office for Immigration Review",
  short: "EOIR",
  call: "Immigration Courts",
  kind: "subagency",
  parent: "doj",
  url: "https://www.justice.gov/eoir",
  established: 1983,
  palette: {
    primary: "#002d70",
    secondary: "#006546",
    accent: "#ffd43f",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Executive_Office_for_Immigration_Review.svg",
  },
  motif: "scales",
  mission: {
    text: "The primary mission of the Executive Office for Immigration Review (EOIR) is to adjudicate immigration cases by fairly, expeditiously, and uniformly interpreting and administering the Nation's immigration laws.",
    url: "https://www.justice.gov/eoir/about-office",
  },
  fact: {
    text: "EOIR was created on January 9, 1983, through a Department of Justice reorganization that combined the Board of Immigration Appeals with the immigration judge function and made the Immigration Courts independent of the former INS.",
    url: "https://www.justice.gov/eoir/about-office",
  },
  seal: {
    file: "public/seals/eoir.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Executive_Office_for_Immigration_Review.svg",
  },
  identifier: {
    about: "https://www.justice.gov/eoir/about-office",
    accessibility: "https://www.justice.gov/accessibility/accessibility-statement",
    foia: "https://www.justice.gov/eoir/freedom-information-act-foia",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.justice.gov/doj/budget-and-performance",
    privacy: "https://www.justice.gov/doj/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/eoir-whipple-federal-building.jpg",
        small: "/media/eoir-whipple-federal-building-sm.jpg",
        alt: "The long, terraced Bishop Henry Whipple Federal Building set into a wooded bluff beneath a blue sky.",
        title: "Bishop Henry Whipple Federal Building, Fort Snelling, Minnesota, August 17, 2020",
        creator: "Tony Webster",
        source: "https://commons.wikimedia.org/wiki/File:Bishop_Henry_Whipple_Federal_Building_(EOIR_Immigration_Court).jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
